module.exports = __webpack_public_path__ + "icon_folder.b7177.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_folder.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_folder.svg
// module chunks = main